import { render, staticRenderFns } from "./ComparisonReportModal.vue?vue&type=template&id=8295ee96&scoped=true&"
import script from "./ComparisonReportModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ComparisonReportModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8295ee96",
  null
  
)

export default component.exports